export default "__VITE_ASSET__99ffb896__"